import { render, staticRenderFns } from "./CustomMultipleSelector.vue?vue&type=template&id=4c5dae46&scoped=true&"
import script from "./CustomMultipleSelector.vue?vue&type=script&lang=js&"
export * from "./CustomMultipleSelector.vue?vue&type=script&lang=js&"
import style0 from "./CustomMultipleSelector.vue?vue&type=style&index=0&id=4c5dae46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5dae46",
  null
  
)

export default component.exports